import styled from "styled-components";

export const PostBoxWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 16px;
    background-color: var(--white);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
    border-radius: 10px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    .postedDetailWrap{
        display: flex;
        width: 100%;
        align-items: center;
        gap: 20px;
        justify-content: space-between;
        .postedDetailContainer{
            display: flex;
            align-items: center;
            gap: 15px;
            /* flex-wrap: wrap; */
            padding-bottom: 16px;
            .postedNameLocatio{
                display: flex;
                width: fit-content;
                flex-wrap: wrap;
                img{
                    min-width: 48px;
                    max-width: 48px;
                    height: 48px;
                }
                .postedNameTime{
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    width: 100%;
                }
                .postedLocationRole{
                    display: flex;
                    align-items: center;
                    & span:first-child{
                        position: relative;
                        padding-right: 16px;
                        margin-right: 16px;
                        &::after{
                            content: "";
                            height: 13px;
                            width: 1px;
                            background-color: var(--lightGrey);
                            position: absolute;
                            right: 0;
                            top: auto;
                            bottom: auto;
                        }
                        
                    }
                    body.rtl & span:first-child{
                        padding-right: 0;
                        padding-left: 16px;
                        margin-right: 0;
                        margin-left: 16px;
                        &::after{
                            right: auto;
                            left: 0;
                        }
                        
                    }
                }
            }
            
        }
        .postedActionBtns{
            display: flex;
            align-items: center;
            gap: 30px;
        }
    }
`
export const MediaContentWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 16px 0px;
    border-bottom: 1px solid var(--border);
    height: 325px;
    
    img{
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-radius: 10px;
    }
`
export const PostedInteractionWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 48px;
    padding-top: 16px;
    .postInteractionBox{
        display: flex;
        align-items: center;
        gap: 12px;
    }
`